import React from "react";
import ToggleButton from "./toggle-button";
import { ButtonRow, notDashedLine, largeDashedLine, smallDashedLine } from "./toolbar-design-system";

export function LineDash({ values, onChange }: { values: Record<number, boolean>; onChange: (value: number) => void }) {
  return (
    <ButtonRow>
      <ToggleButton isOn={values[2]} onClick={() => onChange(2)}>
        {smallDashedLine}
      </ToggleButton>

      <ToggleButton isOn={values[1]} onClick={() => onChange(1)}>
        {largeDashedLine}
      </ToggleButton>

      <ToggleButton isOn={values[0]} onClick={() => onChange(0)}>
        {notDashedLine}
      </ToggleButton>
    </ButtonRow>
  );
}
